import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { createElement, Fragment } from "@wordpress/element";
/**
 * External dependencies
 */

import classnames from 'classnames';
/**
 * Internal dependencies
 */

import HeadingToolbar from './heading-toolbar';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { PanelBody, withFallbackStyles } from '@wordpress/components';
import { createBlock } from '@wordpress/blocks';
import { AlignmentToolbar, BlockControls, InspectorControls, RichText, __experimentalUseColors } from '@wordpress/block-editor';
/**
 * Browser dependencies
 */

var _window = window,
    getComputedStyle = _window.getComputedStyle;

function HeadingEdit(_ref) {
  var backgroundColor = _ref.backgroundColor,
      attributes = _ref.attributes,
      setAttributes = _ref.setAttributes,
      mergeBlocks = _ref.mergeBlocks,
      onReplace = _ref.onReplace,
      className = _ref.className;

  var _experimentalUseColo = __experimentalUseColors([{
    name: 'textColor',
    property: 'color'
  }], {
    contrastCheckerProps: {
      backgroundColor: backgroundColor,
      isLargeText: true
    }
  }, []),
      TextColor = _experimentalUseColo.TextColor,
      InspectorControlsColorPanel = _experimentalUseColo.InspectorControlsColorPanel;

  var align = attributes.align,
      content = attributes.content,
      level = attributes.level,
      placeholder = attributes.placeholder;
  var tagName = 'h' + level;
  return createElement(Fragment, null, createElement(BlockControls, null, createElement(HeadingToolbar, {
    minLevel: 2,
    maxLevel: 5,
    selectedLevel: level,
    onChange: function onChange(newLevel) {
      return setAttributes({
        level: newLevel
      });
    }
  }), createElement(AlignmentToolbar, {
    value: align,
    onChange: function onChange(nextAlign) {
      setAttributes({
        align: nextAlign
      });
    }
  })), createElement(InspectorControls, null, createElement(PanelBody, {
    title: __('Heading Settings')
  }, createElement("p", null, __('Level')), createElement(HeadingToolbar, {
    isCollapsed: false,
    minLevel: 1,
    maxLevel: 7,
    selectedLevel: level,
    onChange: function onChange(newLevel) {
      return setAttributes({
        level: newLevel
      });
    }
  }))), InspectorControlsColorPanel, createElement(TextColor, null, createElement(RichText, {
    identifier: "content",
    tagName: tagName,
    value: content,
    onChange: function onChange(value) {
      return setAttributes({
        content: value
      });
    },
    onMerge: mergeBlocks,
    onSplit: function onSplit(value) {
      if (!value) {
        return createBlock('core/paragraph');
      }

      return createBlock('core/heading', _objectSpread({}, attributes, {
        content: value
      }));
    },
    onReplace: onReplace,
    onRemove: function onRemove() {
      return onReplace([]);
    },
    className: classnames(className, _defineProperty({}, "has-text-align-".concat(align), align)),
    placeholder: placeholder || __('Write heading…')
  })));
}

export default withFallbackStyles(function (node) {
  var backgroundColor = getComputedStyle(node).backgroundColor;

  while (backgroundColor === 'rgba(0, 0, 0, 0)' && node.parentNode) {
    node = node.parentNode;
    backgroundColor = getComputedStyle(node).backgroundColor;
  }

  return {
    backgroundColor: backgroundColor
  };
})(HeadingEdit);